<div class="top-navigation flex align-items-center">
  <div class="ml-auto mr-auto">
    @if (webappAccess()) {
      <bs-global-search-bar></bs-global-search-bar>
    }
  </div>

  <div>
    <div class="flex justify-content-end pr-3">
      <button size="large" class="p-button-rounded p-button-text" severity="contrast" [disabled]="documentationService.status() === 'downloading'" (click)="documentationMenu.toggle($event)" pButton pRipple type="button" [icon]="documentationService.status() === 'downloading' ? 'pi pi-spin pi-spinner' : 'pi pi-question-circle'"></button>
      <p-menu #documentationMenu [model]="documentationItems" [popup]="true" />
      <p-avatar [style]="{ 'background-color': 'unset'}" icon="pi pi-user" shape="circle" size="large" (click)="userPopover.toggle($event)"></p-avatar>
    </div>
    <p-popover #userPopover>
      <ng-template pTemplate="content" class="p-0.5">
        <div class="flex flex-column justify-content-center">
          <div class="align-avatar-customer-name">
            <p-avatar icon="pi pi-user" shape="circle" size="normal"></p-avatar>
            <h3 class="pl-1">{{ customerName }}</h3>
          </div>
          <p class="text-color-secondary m-0 pl-1">{{ tenantRoleData()?.tenant?.tenantName ?? customerId }}</p>

          @if (tenantRoleData()?.role?.name) {
            <div class="pt-2 pl-1">
              <p-chip [label]="tenantRoleData()?.role?.name!" icon="pi pi-id-card" styleClass="text-sm py-1 px-2 align-items-center" />
            </div>
          }

          <div class="flex justify-content-center pt-2">
            <p-toggleswitch [ngModel]="darkModeChecked()" (onChange)="toggleDarkMode()">
              <ng-template #handle let-checked="checked">
                <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-moon' : 'pi-sun']"></i>
              </ng-template>
            </p-toggleswitch>
          </div>

          <p-divider></p-divider>

          <div class="flex justify-content-center">
            @if (!loginDisplay) {
              <p-button severity="info" (onClick)="login()"> Login </p-button>
            }
            @if (loginDisplay) {
              <p-button severity="info" (onClick)="logout()"> Logout </p-button>
            }
          </div>
        </div>
      </ng-template>
    </p-popover>
  </div>

</div>
